import { render, staticRenderFns } from "./StaffManagement.vue?vue&type=template&id=77061d84&scoped=true"
import script from "./StaffManagement.vue?vue&type=script&lang=js"
export * from "./StaffManagement.vue?vue&type=script&lang=js"
import style0 from "./StaffManagement.vue?vue&type=style&index=0&id=77061d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77061d84",
  null
  
)

export default component.exports